/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_All_ActionsInputs */

const en_audit_filter_all_actions = /** @type {(inputs: Audit_Filter_All_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All actions`)
};

const pt_br2_audit_filter_all_actions = /** @type {(inputs: Audit_Filter_All_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as ações`)
};

/**
* | output |
* | --- |
* | "All actions" |
*
* @param {Audit_Filter_All_ActionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_all_actions = /** @type {((inputs?: Audit_Filter_All_ActionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_All_ActionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_all_actions(inputs)
	return pt_br2_audit_filter_all_actions(inputs)
});